var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearCustomAreas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 17H3V7H21V10H19V9H5V15H14V17ZM16 17.6L18.1 15.5L16 13.4L17.4 12L19.5 14.1L21.6 12L23 13.4L20.925 15.5L23 17.6L21.6 19L19.5 16.925L17.4 19L16 17.6Z",
    fill: "#2c5e53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCustomAreas);
export default __webpack_public_path__ + "static/media/clearCustomAreas.c57ebb3acdcb8363c97eb5892e9f4352.svg";
export { ForwardRef as ReactComponent };